import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  initializeFirestore,
  connectFirestoreEmulator,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { firebaseConfig } from '../config/firebase';

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const functions = getFunctions(app);
export const storage = getStorage(app);

// ── Emulator wiring ──
// Enabled when VITE_USE_EMULATORS=1 in `.env.local` (and only on localhost).
// Default ports match firebase.json.
if (import.meta.env.VITE_USE_EMULATORS === '1' && typeof window !== 'undefined') {
  const host = window.location.hostname; // 'localhost' or '127.0.0.1'
  // eslint-disable-next-line no-console
  console.info(`[firebase] Connecting to local emulators on ${host}`);
  try { connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true }); } catch {}
  try { connectFirestoreEmulator(db, host, 8080); } catch {}
  try { connectFunctionsEmulator(functions, host, 5001); } catch {}
  try { connectStorageEmulator(storage, host, 9199); } catch {}
}

export default app;
